var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 9C15.5 7.067 17.067 5.5 19 5.5C20.933 5.5 22.5 7.067 22.5 9C22.5 10.933 20.933 12.5 19 12.5C18.7436 12.5 18.4944 12.4726 18.255 12.4207C18.0058 12.3667 17.7463 12.4431 17.566 12.6234L17.1893 13H15.75C15.3358 13 15 13.3358 15 13.75V15.1893L14.1893 16H12.75C12.3358 16 12 16.3358 12 16.75V18.1893L11.6893 18.5H9.5V16.3107L15.3766 10.434C15.5569 10.2537 15.6333 9.99419 15.5793 9.74498C15.5274 9.50557 15.5 9.25642 15.5 9ZM19 4C16.2386 4 14 6.23858 14 9C14 9.2192 14.0142 9.43541 14.0416 9.64769L8.21967 15.4697C8.07902 15.6103 8 15.8011 8 16V19.25C8 19.6642 8.33579 20 8.75 20H12C12.1989 20 12.3897 19.921 12.5303 19.7803L13.2803 19.0303C13.421 18.8897 13.5 18.6989 13.5 18.5V17.5H14.5C14.6989 17.5 14.8897 17.421 15.0303 17.2803L16.2803 16.0303C16.421 15.8897 16.5 15.6989 16.5 15.5V14.5H17.5C17.6989 14.5 17.8897 14.421 18.0303 14.2803L18.3523 13.9584C18.5646 13.9858 18.7808 14 19 14C21.7614 14 24 11.7614 24 9C24 6.23858 21.7614 4 19 4ZM20 7C19.4477 7 19 7.44772 19 8C19 8.55228 19.4477 9 20 9C20.5523 9 21 8.55228 21 8C21 7.44772 20.5523 7 20 7Z",
    fill: "#8A8AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.c6f23ba1b44a4fcc559695558f02df62.svg";
export { ForwardRef as ReactComponent };